<template>
  <div id="app" :class="classes">
    <header-filzfelt v-if="brand === 'filzfelt'"></header-filzfelt>
    <header-spinneybeck v-if="brand === 'spinneybeck'"></header-spinneybeck>

    <div class="main">
      <router-view />
    </div>

    <footer-filzfelt v-if="brand === 'filzfelt'"></footer-filzfelt>
    <footer-spinneybeck v-if="brand === 'spinneybeck'"></footer-spinneybeck>
  </div>
</template>

<script>
  import * as api from './lib/api'
  import HeaderFilzfelt from './pages/wrappers/HeaderFilzfelt.vue'
  import FooterFilzfelt from './pages/wrappers/FooterFilzfelt.vue'
  import HeaderSpinneybeck from './pages/wrappers/HeaderSpinneybeck.vue'
  import FooterSpinneybeck from './pages/wrappers/FooterSpinneybeck.vue'

  export default {
    components: {
      FooterFilzfelt,
      FooterSpinneybeck,
      HeaderFilzfelt,
      HeaderSpinneybeck
    },

    computed: {
      classes () {
        return {
          filzfelt: this.$store.getters.brand === 'filzfelt',
          spinneybeck: this.$store.getters.brand === 'spinneybeck'
        }
      },
      brand () {
        return this.$store.getters.brand
      },
      design () {
        return this.$store.state.design
      }
    },

    created () {
      this.fetchData()
    },

    mounted() {
      // concierge widget
      if (this.brand === 'spinneybeck') {
        // spinneybeck
        (function (w,i,d,g,e,t,s) {w[d] = w[d]||[];t= i.createElement(g);
          t.async=1;t.src=e;s=i.getElementsByTagName(g)[0];s.parentNode.insertBefore(t, s);
        })(window, document, '_gscq','script', '//widgets.getsitecontrol.com/79502/script.js');
      } else {
        // filzfelt
        (function (w,i,d,g,e,t,s) {w[d] = w[d]||[];t= i.createElement(g);
          t.async=1;t.src=e;s=i.getElementsByTagName(g)[0];s.parentNode.insertBefore(t, s);
        })(window, document, '_gscq','script', '//widgets.getsitecontrol.com/78480/script.js');
      }
    },

    watch: {
      '$route': 'fetchData'
    },

    methods: {
      async fetchData () {
        const { id, slug, brand } = this.$route.params
        if (id && !slug) {
          // if no slug, assume it's an exisiting design
          const { design } = await api.designs.get(id)
          this.$store.commit('setDesignData', design)
        } else if (slug) {
          // otherwise, assume user is starting from a pattern
          this.$store.commit('setPattern', id)
        }

        if (brand) {
          this.$store.commit('setBrand', brand)
        }
      }
    }

  }
</script>

<style>
  @import "styles/legacy.css";
  @import "styles/common.css";
</style>

<style>
  @import "styles/vars.css";

  #app {
    min-width: 700px;
    min-height: 650px;
    background: #fff;
  }

  #app > .main {
    padding: 0 20px;
    margin: 0 auto 100px;
    max-width: 1310px;
    background: transparent;
  }

  .logo {
    margin: 35px 0;
  }
</style>



// WEBPACK FOOTER //
// App.vue?5b2018ac